import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

import { DataService } from 'src/app/services/data.service';
import { NotificationsService } from 'src/app/services/notifications.service';

@Component({
  selector: 'app-notifications-dialog',
  templateUrl: './notifications-dialog.component.html',
  styleUrls: ['./notifications-dialog.component.scss']
})
export class NotificationsDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<NotificationsDialogComponent>,
    public dataService: DataService,
    public notificationsService: NotificationsService
  ) {}

  ngOnInit() {
    localStorage.setItem(
      'readNotificationTimeStamp' + this.dataService.plantCode,
      JSON.stringify(formatDate(new Date(), 'yyyyMMddHHmmss', 'en-US'))
    );
    this.dataService.unreadNotificationCount = 0;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
